<div class="flex items-center">
  <em-box>
    @if (findReplaceGroup; as findReplaceControl) {
      <em-find-replace
        [formControl]="findReplaceControl"
        [touched]="processorFormGroup?.touched"
      ></em-find-replace>
    }
  </em-box>

  <em-icon-button
    icon="delete"
    color="warn"
    (btnClick)="removeFindReplace()"
  ></em-icon-button>
</div>
